<fusioncharts
  [width]="width"
  [height]="height"
  [type]="type"
  [dataFormat]="dataFormat"
  [dataSource]="dataSource"
>
</fusioncharts>

